var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-04",
    clipPath: "url(#clip0_3958_4074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.1663 11.1949V13.0616C11.1663 13.8083 11.1663 14.1817 11.021 14.4669C10.8932 14.7178 10.6892 14.9218 10.4383 15.0496C10.1531 15.1949 9.77974 15.1949 9.03301 15.1949H3.96634C3.2196 15.1949 2.84624 15.1949 2.56102 15.0496C2.31014 14.9218 2.10616 14.7178 1.97833 14.4669C1.83301 14.1817 1.83301 13.8083 1.83301 13.0616V7.99491C1.83301 7.24817 1.83301 6.8748 1.97833 6.58959C2.10616 6.3387 2.31014 6.13473 2.56102 6.0069C2.84624 5.86157 3.2196 5.86157 3.96634 5.86157H5.83301M7.96634 11.1949H13.033C13.7797 11.1949 14.1531 11.1949 14.4383 11.0496C14.6892 10.9218 14.8932 10.7178 15.021 10.4669C15.1663 10.1817 15.1663 9.80831 15.1663 9.06157V3.99491C15.1663 3.24817 15.1663 2.8748 15.021 2.58958C14.8932 2.3387 14.6892 2.13473 14.4383 2.0069C14.1531 1.86157 13.7797 1.86157 13.033 1.86157H7.96634C7.2196 1.86157 6.84624 1.86157 6.56102 2.0069C6.31014 2.13473 6.10616 2.3387 5.97833 2.58958C5.83301 2.8748 5.83301 3.24817 5.83301 3.99491V9.06157C5.83301 9.80831 5.83301 10.1817 5.97833 10.4669C6.10616 10.7178 6.31014 10.9218 6.56102 11.0496C6.84624 11.1949 7.2196 11.1949 7.96634 11.1949Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3958_4074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.528198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f0406186bc3c038901c16b722b2a9d11.svg";
export { ForwardRef as ReactComponent };